import { FC, useCallback, useContext, useEffect } from "react";

import { SocketContext, TeamContext, UserContext } from "../context";
import { BoardPage } from "../pages";
import { Phase } from "../util/enums";
import { IPlayer } from "../interfaces";
import { ConnectionFailedPage, MuteButton } from "../components/atoms";
import { useTranslation } from "react-i18next";
import { SideOptionFacilitator } from "../components/molecules";
import axios from "axios";

const SpectatorRoute: FC<{}> = () => {
    const { socket } = useContext(SocketContext);
    const { teamNumber, roomUsers, game } = useContext(TeamContext);
    const { setEmailOfSelectedPlayerBoard } = useContext(UserContext);
    const { userData, setUserData } = useContext(UserContext);
    const areInGamePhasesActive = (game?.phase === Phase.CHOOSING_SOLUTION_CARDS || game?.phase === Phase.INTRODUCTION ||  game?.phase === Phase.PICK_DILEMMA || game?.phase === Phase.QUESTION_CARD || game?.phase === Phase.ACTION_CARD || game?.phase === Phase.CHOOSE_SOLUTION || game?.phase === Phase.RENDER_SPIN_WHEEL || game?.phase === Phase.SOLUTION_CHOSEN || game?.phase === Phase.SOLUTION_CHOSEN_REWARD || game?.phase === Phase.CONFETTI_CELEBRATION);
    const { t } = useTranslation();

    const currentDilemmaOwnerEmail: any = game?.gameInfo.currentPlayerEmail || "undefined";
    const currentDilemmaOnwerObject: any = game?.players.find( (player: any) => player?.email === currentDilemmaOwnerEmail);

    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];

    
    // const spectatorEmail = urlTokenExtracted + localStorage.getItem("userEmailInCaseHeLogsOut");
    
    useEffect(() => {
        const userDataMapped : any = {
            color: currentDilemmaOnwerObject?.color || "pink",
            fullName: currentDilemmaOnwerObject?.fullName || "Spectator",
            nickname: currentDilemmaOnwerObject?.nickname || "Spectator",
            email: currentDilemmaOwnerEmail,
            image: "images/"+currentDilemmaOwnerEmail
        }

        setEmailOfSelectedPlayerBoard(currentDilemmaOwnerEmail);

        setUserData(userDataMapped);
    }, [game])

    const checkIfAnyOfTheUsersLoggedOutDuringTheGame = useCallback (() => {
        let listOfThePlayers = game?.gameInfo?.players;
        let helperArray = [];
        
        for (const playerEmail in listOfThePlayers) {
            if (listOfThePlayers[playerEmail].status === 3) {

                let expectedPlayer = game?.players.find((player: IPlayer) => { return player.email === playerEmail });
                
                if (expectedPlayer)
                    helperArray.push(expectedPlayer);
            }
        }
    },[game?.gameInfo?.players, game?.players])

    useEffect(() => {
        checkIfAnyOfTheUsersLoggedOutDuringTheGame();
    }, [game?.gameInfo?.players, checkIfAnyOfTheUsersLoggedOutDuringTheGame]);

    const forceSpectator = () => {
        axios({
            method: "post",
            url: process.env.REACT_APP_ADMIN_BACKEND_URL + "api/preactive-matches/get-match-data/",
            data:{
              id: urlTokenExtracted
            }
          })
          .then((res) => {
            if (res.data) {
                const spectatorEmail = urlTokenExtracted + res?.data?.companyEmail
                let payload = {
                    matchId: urlTokenExtracted,
                    gameId: 1,
                    spectator: {
                        email: spectatorEmail,
                    }
                }
                socket?.emit("joinRoomSpectator", payload );
                localStorage.setItem(`${urlTokenExtracted}`, spectatorEmail);
                roomUsers();
            }
          })
          .catch((err: any) => {console.log('Error joining spectaotr', err.message)});
    }

    useEffect(() => {
        forceSpectator();
    }, [])

    const selectTheUserWhoYouWantToBe = (playerEmail: string) => {

        const currentDilemmaOnwerObject: any = game?.players.find( (player: any) => player?.email === playerEmail);
        setEmailOfSelectedPlayerBoard(playerEmail);

        const userDataMapped : any = {
            color: currentDilemmaOnwerObject?.color || "pink",
            fullName: currentDilemmaOnwerObject?.fullName || "Spectator",
            nickname: currentDilemmaOnwerObject?.nickname || "Spectator",
            email: playerEmail,
            image: "images/"+playerEmail
        }

        setUserData(userDataMapped);
    }

    if (!userData) return <div></div>

    const getTheTextForSpectator = () => {
        if(game?.phase) {
            return t("waitingForPlayersToBeReadyText")
        } else {
            return t("theGameIsInactiveText")
        }
    }

    const listOfAllPlayers = () => {
        return game?.players.map( (player: any, index: number) => {
            return(
                <div key={index} onClick={() => selectTheUserWhoYouWantToBe(player?.email)}>
                    {player?.nickname}
                </div>
            )
        })
    }

    return (
        <div>
            <div>
                {/* <button style={{zIndex: 100, position: "absolute"}} onClick={() => forceSpectator()}> roomUsers </button>  */}
                {/* <div style={{zIndex: 100, position: "absolute", left: "100px"}}>   {localStorage.getItem("userEmailInCaseHeLogsOut")} </div> */}
                {/* <div  style={{zIndex: 100, position: "absolute", left: "100px", top: "10px", color: "white", cursor: "pointer", display: "flex"}} >
                    {listOfAllPlayers()}
                </div> */}
                {!game && <ConnectionFailedPage />}
                {(!teamNumber || !userData) && game && <BoardPage />}
                {teamNumber && userData && areInGamePhasesActive ?
                    <BoardPage /> 
                    : 
                    <div>
                        <div className="mid_game_waiting_room_wrapper">
                            <div className="mid_game_waiting_room_box">
                                {getTheTextForSpectator()}
                            </div> 
                        </div> 
                        <SideOptionFacilitator />
                    </div>
                }
                <MuteButton />
            </div>
        </div>
    );
}

export default SpectatorRoute;